export const API_URL = process.env.VUE_APP_BACKEND_URL || 'http://localhost:8080';
